import cm from 'cm'
import { axios as $http, setHeader } from 'cm'
import { getRunTime } from '../../../public-resource/libs/utils/index'
import Bridge from '../../../public-resource/libs/Bridge/Bridge'
import './style.scss'
import qs from 'qs'

// import vconsole from 'vconsole';
// new vconsole();
// console.log('增加打印信息');

const IS_APP = window.$platform.isYixinliApp || window.$platform.isZiXunApp

let share_config = window.share_config

let HOST = getRunTime('//m.xinli001.com')

let query = qs.parse(location.search.replace('?', ''))

window.yxl.stat.init({
  bridge: new Bridge()
})

window.yxl.stat.send({
  name: '咨询-「话题详情页」访问',
  properties: {
    来源入口: decodeURIComponent(decodeURIComponent(query.ref))
  }
})

// APP分享

if (IS_APP) {
  let myBridge = new Bridge({
    methods: [
      {
        method: 'topFuncBtn',
        callback: function(ops) {
          if (ops.name == 'shareReportBtn') {
            var share_Config = {
              sharePageSource: '咨询话题',
              title: share_config.title,
              desc: share_config.desc,
              link: share_config.url,
              imgUrl: share_config.img
            }
            window.yxl.stat.send({
              name: '咨询-话题详情「分享」点击'
            })
            myBridge.call('shareReport', share_Config)
          }
        }
      }
    ]
  })
  myBridge.call('setTitle', { title: '话题详情' })
  // console.log('这里设置了标题');
  myBridge.call('topFuncBtnConfig', {
    btnList: [
      {
        name: 'shareReportBtn',
        showName: '分享',
        visible: 1
      }
    ]
  })
}

// 微信分享
if (window.$platform.isWechat) {
  let currentUrl = document.location.href
  let getWxConfig = `${HOST}/wx/get-wx-package.json`
  $http
    .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
    .then(res => {
      if (res.data.code == 0) {
        var wxConfig = res.data.data

        function loadScript(url, callback) {
          var script = document.createElement('script')
          script.type = 'text/javascript'
          if (typeof callback !== 'undefined') {
            if (script.readyState) {
              script.onreadystatechange = function() {
                if (
                  script.readyState == 'loaded' ||
                  script.readyState == 'complete'
                ) {
                  script.onreadystatechange = null
                  callback()
                }
              }
            } else {
              script.onload = function() {
                callback()
              }
            }
          }
          script.src = url
          document.body.appendChild(script)
        }

        setTimeout(() => {
          loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
            var _config = {
              debug: wxConfig.debug,
              appId: wxConfig.appId,
              timestamp: wxConfig.timestamp,
              nonceStr: wxConfig.nonceStr,
              signature: wxConfig.signature,
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
                'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            }

            // 微信基本配置信息
            wx.config(_config)

            wx.ready(function() {
              let share_Config = {
                sharePageSource: '咨询话题详情页',
                title: share_config.title,
                desc: share_config.desc,
                link: share_config.url,
                imgUrl: share_config.img,

                success: function(res) {
                  window.yxl.stat.send({
                    name: '咨询-话题详情「分享」点击'
                  })
                },
                cancel: function(res) {},
                fail: function(res) {}
              }
              // 分享到朋友圈
              wx.onMenuShareTimeline(share_Config)
              // 分享给朋友
              wx.onMenuShareAppMessage(share_Config)
              // 分享到QQ
              wx.onMenuShareQQ(share_Config)
              // 分享到腾讯微博
              wx.onMenuShareWeibo(share_Config)
              // 分享到QQ空间
              wx.onMenuShareQZone(share_Config)
              wx.updateAppMessageShareData(share_Config)
              wx.updateTimelineShareData(share_Config)
            })
          })
        }, 500)
      }
    })
}

// let expertName = 'asd'

let tabList = document.getElementsByClassName('tabList')[0]
tabList.addEventListener('click', e => {
  let target = e.target
  while (target.tagName.toLowerCase() !== 'a') {
    target = target.parentNode
  }
  if (target.getAttribute('title') === 'index-question') {
    window.yxl.stat.send({
      name: '咨询-话题详情「私信」点击'
    })
    if (IS_APP) return

    if (myId === '' && token === '') {
      // app由后端控制跳转了
      let _href = `${HOST}/account/login?next=${encodeURIComponent(
        window.location.href
      )}`
      window.toast('请先登录')
      setTimeout(() => {
        window.location = _href
      }, 1500)
    } else {
      let Dialog = new yxlDialog({
        title: '发送私信',
        content:
          '<form id="message-form" action="" method="post">' +
          '<p><textarea id="content" class="content" placeholder="@' +
          expertName +
          '：" name="content"></textarea></p>' +
          '</form>',
        ok: function() {
          let msg = document.getElementById('content').value
          // console.log(msg)
          if (msg == '') {
            window.toast('内容不能为空')
            return false
          }

          $http
            .post(postUserMessageUrl, {
              other_id: userId,
              content: msg,
              token: token
            })
            .then(res => {
              const { data } = res
              if (data.code === 0) {
                window.toast(data.message)
              } else {
                window.toast(data.message)
              }
            })
        }
      }).size(7)
    }
  }

  if (target.getAttribute('title') === 'consult-index') {
    window.yxl.stat.send({
      name: '咨询-话题详情「预约按钮」点击'
    })
  }
})



// WEBPACK FOOTER //
// ./src/pages/consult/consultTopic/index.js